import React, { useEffect, createElement } from 'react';
import { DatabaseIcon, GlobeIcon, BrainCircuitIcon, LineChartIcon, ShieldCheckIcon, FileTextIcon, TrendingUpIcon, AlertTriangleIcon, UsersIcon, DownloadIcon, CheckCircleIcon, ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function SuperPlatformAI() {
  // Set page-specific meta tags
  useEffect(() => {
    // Store original values for cleanup
    const originalTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogType = document.querySelector('meta[property="og:type"]');
    const ogImage = document.querySelector('meta[property="og:image"]');
    const ogImageAlt = document.querySelector('meta[property="og:image:alt"]');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    const twitterImageAlt = document.querySelector('meta[name="twitter:image:alt"]');
    const canonical = document.querySelector('link[rel="canonical"]');
    const origDesc = metaDescription?.getAttribute('content') || '';
    const origKeywords = metaKeywords?.getAttribute('content') || '';
    const origOgTitle = ogTitle?.getAttribute('content') || '';
    const origOgDesc = ogDescription?.getAttribute('content') || '';
    const origOgUrl = ogUrl?.getAttribute('content') || '';
    const origOgType = ogType?.getAttribute('content') || '';
    const origOgImage = ogImage?.getAttribute('content') || '';
    const origOgImageAlt = ogImageAlt?.getAttribute('content') || '';
    const origTwitterTitle = twitterTitle?.getAttribute('content') || '';
    const origTwitterDesc = twitterDescription?.getAttribute('content') || '';
    const origTwitterImage = twitterImage?.getAttribute('content') || '';
    const origTwitterImageAlt = twitterImageAlt?.getAttribute('content') || '';
    const origCanonical = canonical?.getAttribute('href') || '';
    // Update title
    document.title = 'Super Platform AI - AI-Powered Strategic Decision Making | COSMO IMAGE AVIATION';
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Super Platform AI: Advanced AI-powered data management and analytics platform for strategic decision-making. Integrated web crawler, document management, and real-time executive dashboard for government institutions.');
    }
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Super Platform AI, AI analytics platform, strategic decision making, data management, web crawler, executive dashboard, government technology, AI-powered insights, real-time analytics, COSMO IMAGE AVIATION');
    }
    if (ogTitle) ogTitle.setAttribute('content', 'Super Platform AI - AI-Powered Strategic Decision Making Platform');
    if (ogDescription) ogDescription.setAttribute('content', 'Advanced AI-powered data management and analytics platform integrating web crawling, document management, and real-time executive dashboard for strategic government decision-making.');
    if (ogUrl) ogUrl.setAttribute('content', 'https://www.cosmoimageaviation.com/super-platform-ai');
    if (ogType) ogType.setAttribute('content', 'product');
    if (ogImage) ogImage.setAttribute('content', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBfxqkLa5b2GcRB3ZnM6Eo/Screenshot_2025-11-11_143200.png');
    if (ogImageAlt) ogImageAlt.setAttribute('content', 'Super Platform AI Dashboard Interface');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Super Platform AI - AI-Powered Strategic Decision Making');
    if (twitterDescription) twitterDescription.setAttribute('content', 'Advanced AI-powered data management and analytics platform for strategic government decision-making with real-time executive dashboard.');
    if (twitterImage) twitterImage.setAttribute('content', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBfxqkLa5b2GcRB3ZnM6Eo/Screenshot_2025-11-11_143200.png');
    if (twitterImageAlt) twitterImageAlt.setAttribute('content', 'Super Platform AI Dashboard Interface');
    if (canonical) canonical.setAttribute('href', 'https://www.cosmoimageaviation.com/super-platform-ai');
    const ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    const ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    const origOgImageWidth = ogImageWidth?.getAttribute('content') || '';
    const origOgImageHeight = ogImageHeight?.getAttribute('content') || '';
    if (ogImageWidth) ogImageWidth.setAttribute('content', '1920');
    if (ogImageHeight) ogImageHeight.setAttribute('content', '1080');
    const ogImageSecureUrl = document.querySelector('meta[property="og:image:secure_url"]');
    const origOgImageSecureUrl = ogImageSecureUrl?.getAttribute('content') || '';
    if (ogImageSecureUrl) ogImageSecureUrl.setAttribute('content', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBfxqkLa5b2GcRB3ZnM6Eo/Screenshot_2025-11-11_143200.png');
    const ogImageType = document.querySelector('meta[property="og:image:type"]');
    const origOgImageType = ogImageType?.getAttribute('content') || '';
    if (ogImageType) ogImageType.setAttribute('content', 'image/png');
    // Add page-specific JSON-LD structured data
    const jsonLd = document.createElement('script');
    jsonLd.type = 'application/ld+json';
    jsonLd.id = 'super-platform-ai-jsonld';
    jsonLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Super Platform AI',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      description: 'AI-Powered Data Management and Analytics Platform for Strategic Decision Making. Integrates web crawling, document management, API integration, and real-time executive dashboard.',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'USD',
        seller: {
          '@type': 'Organization',
          name: 'COSMO IMAGE AVIATION PTE. LTD.',
          url: 'https://www.cosmoimageaviation.com/'
        }
      },
      featureList: 'AI-Driven Prioritization, Real-Time Executive Dashboard, Web & Media Crawler, Document Management, API & Database Integration, Social Media Analysis',
      screenshot: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBfxqkLa5b2GcRB3ZnM6Eo/Screenshot_2025-11-11_143200.png',
      provider: {
        '@type': 'Organization',
        name: 'COSMO IMAGE AVIATION PTE. LTD.',
        url: 'https://www.cosmoimageaviation.com/'
      }
    });
    document.head.appendChild(jsonLd);
    // Add BreadcrumbList JSON-LD
    const breadcrumbLd = document.createElement('script');
    breadcrumbLd.type = 'application/ld+json';
    breadcrumbLd.id = 'super-platform-ai-breadcrumb';
    breadcrumbLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.cosmoimageaviation.com/'
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'Products',
        item: 'https://www.cosmoimageaviation.com/#services'
      }, {
        '@type': 'ListItem',
        position: 3,
        name: 'Super Platform AI',
        item: 'https://www.cosmoimageaviation.com/super-platform-ai'
      }]
    });
    document.head.appendChild(breadcrumbLd);
    window.scrollTo(0, 0);
    return () => {
      document.title = originalTitle;
      if (metaDescription) metaDescription.setAttribute('content', origDesc);
      if (metaKeywords) metaKeywords.setAttribute('content', origKeywords);
      if (ogTitle) ogTitle.setAttribute('content', origOgTitle);
      if (ogDescription) ogDescription.setAttribute('content', origOgDesc);
      if (ogUrl) ogUrl.setAttribute('content', origOgUrl);
      if (ogType) ogType.setAttribute('content', origOgType);
      if (ogImage) ogImage.setAttribute('content', origOgImage);
      if (ogImageAlt) ogImageAlt.setAttribute('content', origOgImageAlt);
      if (ogImageWidth) ogImageWidth.setAttribute('content', origOgImageWidth);
      if (ogImageHeight) ogImageHeight.setAttribute('content', origOgImageHeight);
      if (twitterTitle) twitterTitle.setAttribute('content', origTwitterTitle);
      if (twitterDescription) twitterDescription.setAttribute('content', origTwitterDesc);
      if (twitterImage) twitterImage.setAttribute('content', origTwitterImage);
      if (twitterImageAlt) twitterImageAlt.setAttribute('content', origTwitterImageAlt);
      if (canonical) canonical.setAttribute('href', origCanonical);
      if (ogImageSecureUrl) ogImageSecureUrl.setAttribute('content', origOgImageSecureUrl);
      if (ogImageType) ogImageType.setAttribute('content', origOgImageType);
      document.getElementById('super-platform-ai-jsonld')?.remove();
      document.getElementById('super-platform-ai-breadcrumb')?.remove();
    };
  }, []);
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-white/20" data-id="element-470">
      <Header data-id="element-471" />

      {/* Hero Section */}
      <section className="relative pt-40 pb-32 px-6 bg-navy overflow-hidden isolate" data-id="element-472">
        <div className="container mx-auto max-w-[var(--maxw)] relative z-10 text-center" data-id="element-473">
          <div className="max-w-4xl mx-auto" data-id="element-474">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-light mb-8 text-white tracking-tight" data-id="element-475">
              <span className="font-bold" data-id="element-476">Super Platform</span> AI
            </h1>
            <p className="text-xl md:text-2xl mb-12 text-gray-400 font-light leading-relaxed" data-id="element-477">
              AI-Powered Data Management and Analytics Platform for Strategic
              Decision Making
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-478">
              <button onClick={() => scrollToSection('features')} className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300" data-id="element-479">
                View Features
              </button>
              <a href="https://drive.google.com/file/d/1gYyQ_UrtRIl6V5GrMtJMq9ink_NMuEgB/view?pli=1" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-480">
                <DownloadIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-481" />
                Download Brochure
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-24" data-id="element-482">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-483">
              <BrainCircuitIcon className="w-8 h-8 text-white/50 mb-6 mx-auto" strokeWidth={1} data-id="element-484" />
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-485">AI-Driven</h3>
              <p className="text-gray-400 font-light" data-id="element-486">
                Automatic prioritization powered by artificial intelligence
              </p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-487">
              <LineChartIcon className="w-8 h-8 text-white/50 mb-6 mx-auto" strokeWidth={1} data-id="element-488" />
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-489">Real-Time</h3>
              <p className="text-gray-400 font-light" data-id="element-490">
                Executive dashboard with up-to-date data
              </p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-491">
              <ShieldCheckIcon className="w-8 h-8 text-white/50 mb-6 mx-auto" strokeWidth={1} data-id="element-492" />
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-493">Strategic</h3>
              <p className="text-gray-400 font-light" data-id="element-494">
                Designed for high-level government institutions
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Platform Preview Section */}
      <section className="py-32 bg-surface" data-id="element-495">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-496">
          <div className="text-center mb-20" data-id="element-497">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-498">
              <span className="font-bold" data-id="element-499">Platform</span>{' '}
              <span className="font-light" data-id="element-500">Interface</span>
            </h2>
            <p className="text-xl text-gray-400 font-light max-w-3xl mx-auto mt-8" data-id="element-501">
              Experience a powerful, intuitive dashboard designed for strategic
              decision-making with real-time data visualization and AI-powered
              insights.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-2 rounded-2xl shadow-2xl overflow-hidden" data-id="element-502">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fBfxqkLa5b2GcRB3ZnM6Eo/Screenshot_2025-11-11_143200.png" alt="Super Platform AI Dashboard Interface" className="w-full h-auto rounded-xl" data-id="element-503" />
          </div>
        </div>
      </section>

      {/* Core Concept */}
      <section id="concept" className="py-32 bg-navy" data-id="element-504">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-505">
          <div className="text-center mb-20" data-id="element-506">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-507">
              <span className="font-bold" data-id="element-508">Core</span>{' '}
              <span className="font-light" data-id="element-509">Concept</span>
            </h2>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-12 rounded-2xl" data-id="element-510">
            <p className="text-xl md:text-2xl mb-12 text-white font-light text-center max-w-4xl mx-auto" data-id="element-511">
              Super Platform AI is an AI-powered data management and analytics
              platform that integrates:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-512">
              <div className="flex items-start gap-6" data-id="element-513">
                <div className="p-4 border border-white/10 rounded-full bg-white/5" data-id="element-514">
                  <GlobeIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-515" />
                </div>
                <div data-id="element-516">
                  <h3 className="font-medium text-xl mb-2 text-white" data-id="element-517">
                    Web & Media Crawler
                  </h3>
                  <p className="text-gray-400 font-light leading-relaxed" data-id="element-518">
                    Automated data collection from various online sources
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-6" data-id="element-519">
                <div className="p-4 border border-white/10 rounded-full bg-white/5" data-id="element-520">
                  <FileTextIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-521" />
                </div>
                <div data-id="element-522">
                  <h3 className="font-medium text-xl mb-2 text-white" data-id="element-523">
                    Document Management
                  </h3>
                  <p className="text-gray-400 font-light leading-relaxed" data-id="element-524">
                    Integrated management of strategic document files
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-6" data-id="element-525">
                <div className="p-4 border border-white/10 rounded-full bg-white/5" data-id="element-526">
                  <DatabaseIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-527" />
                </div>
                <div data-id="element-528">
                  <h3 className="font-medium text-xl mb-2 text-white" data-id="element-529">
                    API & Database Integration
                  </h3>
                  <p className="text-gray-400 font-light leading-relaxed" data-id="element-530">
                    Synchronization with internal institutional systems
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-6" data-id="element-531">
                <div className="p-4 border border-white/10 rounded-full bg-white/5" data-id="element-532">
                  <LineChartIcon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-533" />
                </div>
                <div data-id="element-534">
                  <h3 className="font-medium text-xl mb-2 text-white" data-id="element-535">
                    Real-Time Dashboard
                  </h3>
                  <p className="text-gray-400 font-light leading-relaxed" data-id="element-536">
                    Visualization of priorities and executive insights
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-8 border-t border-white/10 text-center" data-id="element-537">
              <p className="text-gray-400 font-light" data-id="element-538">
                <span className="text-white font-medium mr-2" data-id="element-539">
                  Platform Focus:
                </span>
                Transform scattered data into structured, prioritized, and
                actionable insights for strategic decision-making.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Flow */}
      <section id="flow" className="py-32 bg-surface" data-id="element-540">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-541">
          <div className="text-center mb-20" data-id="element-542">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-543">
              <span className="font-bold" data-id="element-544">Product</span>{' '}
              <span className="font-light" data-id="element-545">Flow</span>
            </h2>
          </div>

          <div className="space-y-8 max-w-5xl mx-auto" data-id="element-546">
            {[{
            title: '1. Data Collection',
            icon: GlobeIcon,
            items: ['Web crawler (news portals, online media, official websites)', 'Social media & public conversations (via API)', 'Internal file upload: PDF, JPEG, Excel, report documents', 'API & agency database integration']
          }, {
            title: '2. Data Management & Synchronization',
            icon: DatabaseIcon,
            items: ['Automatic normalization & categorization', 'Issue tagging: security, politics, economy, social, capital city, energy, disinformation', 'Structured storage in AI Priority Database']
          }, {
            title: '3. Prioritization Engine',
            icon: BrainCircuitIcon,
            items: ['Automatic priority recommendations from AI', 'Manual adjustment by analysts', 'Personalized priorities per institution / per leader']
          }, {
            title: '4. Analytics & Dashboard',
            icon: LineChartIcon,
            items: ['Real-time Executive Dashboard', 'Executive summary, trends, issue escalation', 'Data-driven policy recommendations', 'Output can be exported as official reports']
          }].map((step, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-547">
                <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-548">
                  <div className="p-5 border border-white/10 rounded-full bg-white/5 flex-shrink-0" data-id="element-549">
                    <step.icon className="w-8 h-8 text-white/70" strokeWidth={1} data-id="element-550" />
                  </div>
                  <div className="flex-1" data-id="element-551">
                    <h3 className="text-2xl font-medium text-white mb-6" data-id="element-552">
                      {step.title}
                    </h3>
                    <ul className="space-y-4" data-id="element-553">
                      {step.items.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-554">
                          <span className="text-white/30 mt-1 text-sm font-light" data-id="element-555">
                            0{i + 1}
                          </span>
                          <span className="text-gray-400 font-light text-lg" data-id="element-556">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Core Features */}
      <section id="features" className="py-32 bg-navy" data-id="element-557">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-558">
          <div className="text-center mb-20" data-id="element-559">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-560">
              <span className="font-bold" data-id="element-561">Core</span>{' '}
              <span className="font-light" data-id="element-562">Features</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-563">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-12 rounded-2xl" data-id="element-564">
              <FileTextIcon className="w-10 h-10 text-white/50 mb-8" strokeWidth={1} data-id="element-565" />
              <h3 className="text-2xl font-medium text-white mb-8" data-id="element-566">
                A. Data Management
              </h3>
              <ul className="space-y-4" data-id="element-567">
                <li className="flex items-start gap-4" data-id="element-568">
                  <span className="text-white/30 mt-1" data-id="element-569">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-570">
                    Multi-format upload (.pdf, .jpeg, .xlsx, .docx, etc.)
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-571">
                  <span className="text-white/30 mt-1" data-id="element-572">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-573">
                    Management of strategic data archives in one integrated
                    platform
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-574">
                  <span className="text-white/30 mt-1" data-id="element-575">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-576">
                    AI-powered fast search (keywords, entities, issues)
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-12 rounded-2xl" data-id="element-577">
              <GlobeIcon className="w-10 h-10 text-white/50 mb-8" strokeWidth={1} data-id="element-578" />
              <h3 className="text-2xl font-medium text-white mb-8" data-id="element-579">
                B. Web Crawler & Integration
              </h3>
              <ul className="space-y-4" data-id="element-580">
                <li className="flex items-start gap-4" data-id="element-581">
                  <span className="text-white/30 mt-1" data-id="element-582">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-583">
                    Automatic scraping from various news sites & official
                    sources
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-584">
                  <span className="text-white/30 mt-1" data-id="element-585">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-586">
                    Simultaneous multi-scraper for speed and broad coverage
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-587">
                  <span className="text-white/30 mt-1" data-id="element-588">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-589">
                    API & internal agency database integration
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-12 rounded-2xl" data-id="element-590">
              <TrendingUpIcon className="w-10 h-10 text-white/50 mb-8" strokeWidth={1} data-id="element-591" />
              <h3 className="text-2xl font-medium text-white mb-8" data-id="element-592">
                C. AI Priority Processing List
              </h3>
              <ul className="space-y-4" data-id="element-593">
                <li className="flex items-start gap-4" data-id="element-594">
                  <span className="text-white/30 mt-1" data-id="element-595">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-596">
                    <strong className="text-white font-medium" data-id="element-597">
                      AI-Driven Priority:
                    </strong>{' '}
                    system recommends priority issues based on volume, tone,
                    risk, and trends
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-598">
                  <span className="text-white/30 mt-1" data-id="element-599">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-600">
                    <strong className="text-white font-medium" data-id="element-601">
                      Manual Override:
                    </strong>{' '}
                    analysts can change priorities according to policy needs
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-602">
                  <span className="text-white/30 mt-1" data-id="element-603">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-604">
                    <strong className="text-white font-medium" data-id="element-605">
                      Persona-based View:
                    </strong>{' '}
                    priorities customized for national leaders, intelligence
                    units, government PR, and specific issue desks
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-12 rounded-2xl" data-id="element-606">
              <LineChartIcon className="w-10 h-10 text-white/50 mb-8" strokeWidth={1} data-id="element-607" />
              <h3 className="text-2xl font-medium text-white mb-8" data-id="element-608">
                D. Executive Dashboard
              </h3>
              <ul className="space-y-4" data-id="element-609">
                <li className="flex items-start gap-4" data-id="element-610">
                  <span className="text-white/30 mt-1" data-id="element-611">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-612">
                    <strong className="text-white font-medium" data-id="element-613">
                      Real-Time AI Analysis:
                    </strong>{' '}
                    issue summary, escalation & potential crisis detection,
                    policy recommendations
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-614">
                  <span className="text-white/30 mt-1" data-id="element-615">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-616">
                    <strong className="text-white font-medium" data-id="element-617">
                      Social Media Analysis AI:
                    </strong>{' '}
                    public sentiment mapping, hoax & disinformation detection
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-618">
                  <span className="text-white/30 mt-1" data-id="element-619">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-620">
                    <strong className="text-white font-medium" data-id="element-621">
                      Dynamic Priority & Attention:
                    </strong>{' '}
                    analytical focus that can be adjusted to current context
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-622">
                  <span className="text-white/30 mt-1" data-id="element-623">—</span>
                  <span className="text-gray-400 font-light text-lg" data-id="element-624">
                    <strong className="text-white font-medium" data-id="element-625">
                      Real-Time Collection:
                    </strong>{' '}
                    continuous synchronization from all data sources
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Strategic Value */}
      <section id="value" className="py-32 bg-surface" data-id="element-626">
        <div className="container mx-auto max-w-[var(--maxw)] px-6" data-id="element-627">
          <div className="text-center mb-20" data-id="element-628">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-white tracking-tight" data-id="element-629">
              <span className="font-bold" data-id="element-630">Strategic</span>{' '}
              <span className="font-light" data-id="element-631">Value</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-632">
            {[{
            icon: AlertTriangleIcon,
            title: 'Reduce Information Overload',
            description: 'Data is directly presented as insights, not just raw data'
          }, {
            icon: TrendingUpIcon,
            title: 'Fast Decision Making',
            description: 'Support decisions in dynamic national environments (security, politics, economy, cyber, propaganda)'
          }, {
            icon: ShieldCheckIcon,
            title: 'Single Source of Truth',
            description: 'Become a trusted cross-agency analytical center'
          }, {
            icon: UsersIcon,
            title: 'Full Customization',
            description: 'Can be adapted to the structure and SOPs of government institutions'
          }, {
            icon: BrainCircuitIcon,
            title: 'AI-Powered Insights',
            description: 'Deep analysis based on artificial intelligence for accurate insights'
          }, {
            icon: DatabaseIcon,
            title: 'Comprehensive Integration',
            description: 'Connect all strategic data sources in one platform'
          }].map((value, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-633">
                <value.icon className="w-8 h-8 text-white/50 mb-6" strokeWidth={1} data-id="element-634" />
                <h3 className="text-xl font-medium text-white mb-4" data-id="element-635">
                  {value.title}
                </h3>
                <p className="text-gray-400 font-light leading-relaxed" data-id="element-636">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-32 bg-navy text-center" data-id="element-637">
        <div className="container mx-auto max-w-4xl px-6" data-id="element-638">
          <UsersIcon className="w-12 h-12 mx-auto mb-8 text-white/50" strokeWidth={1} data-id="element-639" />
          <h2 className="text-3xl md:text-5xl font-light mb-8 text-white" data-id="element-640">
            <span className="font-bold" data-id="element-641">Primary</span> Target
          </h2>
          <p className="text-xl md:text-2xl mb-12 font-light text-gray-400 leading-relaxed" data-id="element-642">
            Specifically designed for high-level government institutions,
            ministries/agencies, and strategic analytical units
          </p>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-2xl" data-id="element-643">
            <p className="text-lg text-gray-300 font-light" data-id="element-644">
              Examples: National Defense Council, Ministries, Intelligence
              Agencies, and Government Strategic Units
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-surface text-center" data-id="element-645">
        <div className="container mx-auto max-w-4xl px-6" data-id="element-646">
          <h2 className="text-3xl md:text-5xl font-light text-white mb-8" data-id="element-647">
            <span className="font-bold" data-id="element-648">Ready to Optimize</span> Strategic
            Decision Making?
          </h2>
          <p className="text-xl text-gray-400 font-light mb-12" data-id="element-649">
            Contact us for a demo and further consultation
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-650">
            <a href="mailto:contact@cosmoimageaviation.co" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300" data-id="element-651">
              Contact Us
            </a>
            <a href="https://drive.google.com/file/d/1gYyQ_UrtRIl6V5GrMtJMq9ink_NMuEgB/view?pli=1" target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/30 hover:bg-white/10 text-white tracking-widest uppercase text-xs font-medium py-4 px-10 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-652">
              <DownloadIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-653" />
              Download Brochure
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-654" />
    </div>;
}